<template>
  <Switcher class="auth_add-user" ref="forms" turnable :display="!userLogin">
    <template v-slot:switcher>
      <div
        :class="$refs.forms && $refs.forms.isDisplayed ? 'light-blue' : 'blue'"
        class="auth_add-user__button button"
        v-if="userLogin"
      >
        {{ $refs.forms && $refs.forms.isDisplayed
          ? $t('components.session.button.add_user_active')
          : $t('components.session.button.add_user')
        }}
      </div>
    </template>
    <Tumbler
      ref="tumbler"
      class="auth_add-user__tumbler auth_session-forms"
    >
      <Switcher
        :onShow="s => $refs.tumbler.switcherShow(s)"
        class="auth_session-forms__login"
        ref="loginForm"
        display
      >
        <template v-slot:switcher>
          <div
            class="auth_session-forms__login-button"
            :class="{active: $refs.loginForm && $refs.loginForm.isDisplayed}"
          >
            {{ $refs.loginForm && $refs.loginForm.isDisplayed
             ? $t('components.session.button.login_active')
             : $t('components.session.button.login')
           }}
          </div>
        </template>
        <LoginForm class="auth_session-forms__login-form" />
      </Switcher>
      <Switcher
        :onShow="s => $refs.tumbler.switcherShow(s)"
        class="auth_session-forms__register"
        ref="registerForm"
      >
        <template v-slot:switcher>
          <div
            class="auth_session-forms__register-button"
            :class="{active: $refs.registerForm && $refs.registerForm.isDisplayed}"
          >
            {{ $refs.registerForm && $refs.registerForm.isDisplayed
              ? $t('components.session.button.register_active')
              : $t('components.session.button.register')
            }}
          </div>
        </template>
        <RegisterForm class="auth_session-forms__register-form" />
      </Switcher>
    </Tumbler>
  </Switcher>
</template>

<script>
  import { eventBus, EVENTS } from "../../event_bus.js";
  import LoginForm            from "../auth/login_form.vue";
  import RegisterForm         from "../auth/register_form.vue";
  import { Modal, Switcher, Tumbler } from "../../elements";

  export default {
    name: "Forms",
    components: {
      LoginForm,
      RegisterForm,
      Switcher,
      Tumbler,
    },
    props:{
      userLogin: String
    },
    methods: {
      close() {
        this.$refs.forms.close();
      },
      show() {
        this.$refs.forms.show();
      },
    },
    created() {
      eventBus.$on(EVENTS.User.Auth.Success, this.close);
    },
    destroyed() {
      eventBus.$off(EVENTS.User.Auth.Success, this.close);
    },
  }
</script>
